import React, { useState } from 'react'
import GridComponent from '../shared/grid'
import { Autocomplete, Dialog, DialogContent, TextField } from '@mui/material'
import { CancelIcon, ConHeaderDeleteChatIcon, CustomFiledEditActiveIcon, CustomFiledEditIcon, DateFormatIcon, DeleteButtonIcon, DeleteChatIcon, DeleteMessageIcon, FbAlertErrorIcon, NewMessageIcon, NumberFormatIcon, TextFormatIcon } from '../../icon'
import ButtonComponent from '../shared/button/button.component'
import { buttonLabels, emptyLabels } from '../shared/constants'
import { CustomFieldModel, mapToCustomFields, mapToUser, CustomFieldTypes } from '../../models/conversations'
import { ChannelUserModel, UserModel, mapToChannelUser } from '../../models/users.model'
import { useSelector } from 'react-redux'
import * as selector from "../../selectors/selectors"
import { ColDef } from 'ag-grid-community'
import ConfirmDialog from "../shared/confirm-dialog.component";
import { ChannelContactServices } from '../../services/channels/ChannelContactService'


const FieldFormateOptions = [{ Type: "Text", Value: "Text" }, { Type: "Number", Value: "Number" }, { Type: "Date (DD/MM/YY)", Value: "Date (DD/MM/YY)" }]
interface IProps {
    CloseCustomField: () => void;
    GetchannelContacts: () => void;
}

const ContactAddCustomField = (props: IProps) => {
    const IsMobieldevice: boolean = useSelector(selector.isMobileDevice)
    const [isNewCustonFeild, setIsNewCustonField] = useState<boolean>(true)
    const [custonfieldName, setCustonFieldName] = useState<string>()
    const [customFieldType, setCustomFieldType] = useState<string>("")
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [allCustomFields, setAllCustomFields] = useState<CustomFieldModel[]>([])
    const [newCustomFields, setNewCustomFields] = useState<CustomFieldModel[]>([])
    const [selectedCustomFields, setSelectedCustomFields] = useState<any>([])
    const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>();
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [gridApi, setGridApi] = useState<any>();
    const [columnApi, SetColumnApi] = useState<any>(null)
    const [editrowId, setEditrowId] = useState<string>("")


    const user = mapToChannelUser(JSON.parse(localStorage.getItem("current-user"))) as ChannelUserModel;

    const ManageCustomFieldsColumnDefs: ColDef[] = [
        {
            field: "Key",
            headerName: "Custom field name",
            wrapText: true,
            autoHeight: true,
            headerCheckboxSelection: IsMobieldevice ? false : true,
            checkboxSelection: IsMobieldevice ? false : true,
            minWidth: 280,
            cellRenderer: (params) => {
                return <div className="">
                    {isEdit ?
                        <TextField
                            name={"FirstName"}
                            className={`br-text-field br-1 mt-1 w-p-99`}
                            placeholder="First Name*"
                            required
                            error={!newCustomFields.find(x => x.ID === params.data.ID)?.Name?.length}
                            fullWidth
                            size='small'
                            InputProps={{
                                classes: {
                                    input: 'color-text-field-font h5-regular p-1 '
                                }
                            }}
                            autoFocus={params.data.ID === editrowId}
                            value={newCustomFields.find(x => x.ID === params.data.ID)?.Name}
                            onChange={(e) => onChange(e.target.value, params.data)}
                        />
                        :
                        <div>{params.data.Name}</div>
                    }
                </div>
            }
        },
        {
            field: "Type",
            headerName: "Format",
            cellRenderer: params => {
                return params.data.Type === "Text" ? <TextFormatIcon /> : params.data.Type === "Number" ? <NumberFormatIcon /> : <DateFormatIcon />
            }
        },
    ]

    const onChange = (updateValue: string, data: CustomFieldModel) => {
        setNewCustomFields(newCustomFields.map(x => x.ID === data?.ID ? { ...x, Name: updateValue } : x))
        setEditrowId(data.ID)
    }

    const onGridReady = (params) => {
        setGridApi(params.api)
        SetColumnApi(params.columnApi)
    }


    const handleCustomFieldName = (name: string) => {
        setCustonFieldName(name)
    }

    const closeCustomField = () => {
        setCustonFieldName("");
        setCustomFieldType("");
        props.CloseCustomField()
    }

    const addCustomField = () => {
        let data = {
            name: custonfieldName,
            type: customFieldType
        }
        setIsLoading(true)
        ChannelContactServices.addCustomFields(user.OrganizationID, data).then((res) => {
            setCustonFieldName("");
            setCustomFieldType("");
            setIsLoading(false)
            showAllCustomFields()
            setIsNewCustonField(false)
            props.GetchannelContacts()
        }).catch((err) => {
            setIsLoading(false)
        })
    }

    const showAllCustomFields = () => {
        setIsNewCustonField(false)
        setSelectedCustomFields([])
        setCustonFieldName("")
        setIsEdit(false)
        ChannelContactServices.getAllCustomFields(user.OrganizationID).then((res) => {
            setAllCustomFields(res.data.map(mapToCustomFields))
            setNewCustomFields(res.data.map(mapToCustomFields))
        }).catch((err) => {

        })
    }

    const onSelectionChanged = () => {
        let SelectedCustomFields = gridApi.getSelectedRows()
        if (gridApi && SelectedCustomFields.length >= 0) {
            setSelectedCustomFields(SelectedCustomFields)
        }
    }

    const DeleteCustomFields = (isConfim: boolean) => {
        if (!!isConfim) {
            let data = selectedCustomFields?.map(x => x.ID)
            ChannelContactServices.deleteCustomFields(user.OrganizationID, { fieldids: data }).then((res) => {
                showAllCustomFields()
                setOpenConfirmDialog(false)
                setIsEdit(false)
                props.GetchannelContacts()
            }).catch((err) => {
                setOpenConfirmDialog(false)
            })
        }
        else {
            setOpenConfirmDialog(false)
        }
    }

    const handleEditCustomFieldName = () => {
        setIsEdit(!isEdit);
        setNewCustomFields(allCustomFields);
        setEditrowId("")
    }

    const submitUpdatedCustomFields = () => {
        setIsLoading(true)
        ChannelContactServices.updateCustomFields(user.OrganizationID, newCustomFields).then((res) => {
            setIsLoading(false)
            showAllCustomFields()
            props.GetchannelContacts()
        }).catch((err) => {
            setIsLoading(false)
        })
    }

    return (
        <div>
            <Dialog
                fullWidth
                onClose={() => props.CloseCustomField()}
                aria-labelledby="responsive-dialog-title"
                open={true}
                classes={{ paper: "br-2 dialogue-shadow w-90 bg-color-secondary " }}
            >
                <DialogContent className='p-2'>
                    <div className='d-flex justify-between align-center'>
                        <div className='d-flex'>
                            <div className={`px-2 py-1 brt-1 h3-medium c-pointer ${isNewCustonFeild ? "bg-color-primary-light color-secondary" : "bg-color-grid color-add-custom-hide-color"}`} onClick={() => { setIsNewCustonField(true); setCustonFieldName("") }}>
                                + New Field
                            </div>
                            <div className={`px-2 py-1 brt-1 c-pointer h3-medium ${!isNewCustonFeild ? "bg-color-primary-light color-secondary" : "bg-color-grid color-add-custom-hide-color"} `} onClick={() => showAllCustomFields()}>
                                Manage Fields
                            </div>
                        </div>
                        <div className='d-flex align-center'>
                            {!isNewCustonFeild && !!selectedCustomFields?.length &&
                                <DeleteButtonIcon className='mr-2 c-pointer' onClick={() => setOpenConfirmDialog(true)} />
                            }
                            {!isNewCustonFeild &&
                                <div className={`d-flex justify-center align-center w-3 h-3 mr-1 c-pointer ${isEdit ? " bg-color-primary-icon-hover" : ""}`}> <CustomFiledEditIcon className={`w-2 h-2 `} onClick={() => handleEditCustomFieldName()} />
                                </div>
                            }
                            <CancelIcon onClick={() => closeCustomField()} className='c-pointer' />
                        </div>
                    </div>
                    <div className="bg-color-grid h-45">
                        {
                            isNewCustonFeild ?
                                <div className='p-4'>
                                    <div className='color-text-field-font h4-regular'>
                                        Custom field name
                                    </div>
                                    <div>
                                        <TextField
                                            autoFocus
                                            className="w-p-100 h-p-100 mt-1"
                                            name="firstName"
                                            placeholder="Field Name"
                                            variant="outlined"
                                            required
                                            fullWidth
                                            value={custonfieldName}
                                            onChange={(e) =>
                                                handleCustomFieldName(e.target.value)
                                            }
                                            InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                            autoComplete='no'
                                        />
                                    </div>
                                    <div className='color-text-field-font h4-regular mt-3'>
                                        Field format
                                    </div>
                                    <Autocomplete
                                        size="medium"
                                        classes={{ input: 'h2 color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        options={FieldFormateOptions}
                                        disableClearable
                                        getOptionLabel={(option) => option?.Type}
                                        onChange={(event: any, value: any | null) => {
                                            if (value) {
                                                setCustomFieldType(value.Type)
                                            }
                                            else {
                                                setCustomFieldType(null)
                                            }
                                        }}
                                        value={{ Type: customFieldType }}
                                        renderOption={(defaultprops, option: any) => (
                                            <li {...defaultprops} className={"h2 p-1 d-flex justify-between w-p-90 c-pointer"}>
                                                {option.Type}
                                            </li>
                                        )}
                                        renderInput={(params) => <TextField {...params} name="Select formate" required variant="outlined" />}
                                    />
                                    <div className="d-flex my-4">
                                        <ButtonComponent OnClick={() => addCustomField()} ButtonLabel={buttonLabels.ADD} ClassName={"px-4 ml-auto"} Variant={(!!custonfieldName && !!customFieldType) ? "primary-btn-small" : "disabled-btn-small"} Loading={isLoading} />
                                        <ButtonComponent OnClick={() => closeCustomField()} ButtonLabel={buttonLabels.CANCEL} ClassName={"ml-2"} Variant={"secondary-btn-small"} />
                                    </div>
                                </div>
                                :
                                <div className='h-p-88'>
                                    <GridComponent
                                        ColumnDefs={ManageCustomFieldsColumnDefs}
                                        IsPaginationEnabled={false}
                                        OnGridReady={onGridReady}
                                        RowData={allCustomFields}
                                        OnSelectionChanged={onSelectionChanged}
                                        OnGridRowClick={() => { }}
                                        EmptyLabel={emptyLabels.CUSTOM_FIELDS}
                                        gridApi={gridApi}
                                        LockVisible={false}
                                    />
                                    <div className="d-flex px-2 justify-between align-center">
                                        <div>
                                            {newCustomFields?.some(item => item?.Name.trim() === "") &&
                                                <div className='d-flex align-center'>
                                                    <FbAlertErrorIcon />
                                                    <span className='ml-1 h4-regular color-primary-danger'>Custom field name cannot be blank</span>
                                                </div>}
                                        </div>
                                        <div className='d-flex'>
                                            <ButtonComponent OnClick={() => submitUpdatedCustomFields()} ButtonLabel={buttonLabels.SAVE} ClassName={"px-4"} Variant={(!isEdit || newCustomFields?.some(item => item?.Name.trim() === "")) ? "disabled-btn-small" : "primary-btn-small"} Loading={isLoading} />
                                            <ButtonComponent OnClick={() => closeCustomField()} ButtonLabel={buttonLabels.CANCEL} ClassName={"ml-2"} Variant={"secondary-btn-small"} />
                                        </div>
                                    </div>
                                </div>
                        }
                    </div>
                </DialogContent>
            </Dialog>

            {openConfirmDialog &&
                <ConfirmDialog
                    ButtonName={"Delete"}
                    onClose={(confirm) => DeleteCustomFields(confirm)}
                    Show={openConfirmDialog}
                    Text={"Are you sure you want to delete all fields?"}
                    Loading={isLoading}
                />
            }
        </div>
    )
}

export default ContactAddCustomField
